import React, { useState } from 'react'
import { View } from '@instructure/ui-view'
import { Flex } from "@instructure/ui-flex"
import { Spinner } from "@instructure/ui-spinner"
import { TextInput } from "@instructure/ui-text-input"
import { Button } from "@instructure/ui-buttons"
import { connect } from 'react-redux'
import { IconAddLine } from '@instructure/ui-icons'
import { addSections, getSections } from '../../actions/courses'
import { Alert } from '@instructure/ui-alerts'
import { ScreenReaderContent } from '@instructure/ui-a11y-content'

const AddSections = ({ token, addSections, courseId, sections, sectionCreated }) => {
  const [newSectionName, setNewSectionName] = useState("")
  const [uiError, setUiError] = useState(false)
  const [errorMessageInfo, setErrorMessageInfo] = useState("")

  const handleSectionChange = (event, value) => {
    setNewSectionName(value)
    setUiError(false)
  }

  const handleAddSection = () => {
    if (token && newSectionName) {
      const isSectionDuplicated = !!sections.find(item =>
        item.name.trim().toLowerCase() === newSectionName.trim().toLowerCase()
      )

      if (isSectionDuplicated) {
        setUiError(true)
        setErrorMessageInfo("Section name already exists")
      } else {
        addSections(newSectionName, courseId, token)
        setNewSectionName("")
      }
    } else {
      setUiError(true)
      setErrorMessageInfo("Section cannot be created without a name")
    }
  }

  const renderAlert = (message, variant, timeout = 0) => {
    return (
        <Alert
          timeout={timeout}
          variant={variant}
          renderCloseButtonLabel="Close"
          onDismiss={() => setUiError(false)}
          margin="none x-small"
        >
          {message}
        </Alert>
    )
  }


  return (
    <View as='div' position='relative'>
      <Flex alignItems="center">
        <Flex.Item>
          <TextInput
            type="text"
            renderLabel="Add a new Section:"
            value={newSectionName}
            screenReaderLabel="Add a new Section"
            placeholder="e.g. New Section Name"
            onChange={handleSectionChange}
            interaction={sectionCreated?.working ? 'disabled' : 'enabled'}
            messages={[{ text: 'Section name must be unique', type: 'hint' }]}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                handleAddSection();
              }
            }}
          />
        </Flex.Item>
        <Flex.Item>
          <Button
            margin="none x-small"
            color="primary"
            renderIcon={IconAddLine}
            onClick={handleAddSection}
            interaction={sectionCreated?.working ? 'disabled' : 'enabled'}
          >
            <ScreenReaderContent>Add </ScreenReaderContent>Section
          </Button>
        </Flex.Item>
        <Flex.Item position="relative" shouldGrow={true}>
          {sectionCreated?.working && <Spinner renderTitle="Loading" />}
          {sectionCreated?.result && renderAlert('Section created successfully', 'success', 2000)}
          {uiError && renderAlert(errorMessageInfo, 'error', 2000)}
          {sectionCreated?.error && renderAlert(sectionCreated.error.message, 'error', 0)}
        </Flex.Item>
      </Flex>
    </View>
  );
}

const mapStateToProps = (state) => {
  const { userAccess: { jwtToken }, canvas: { canvasCourse }, courses: { sectionCreated, sections } } = state
  return {
    token: jwtToken,
    courseId: canvasCourse && canvasCourse.courseId,
    sectionCreated,
    sections: sections && sections.result && sections.result.data
  }
}

export default connect(mapStateToProps, { addSections, getSections })(AddSections)